<ng-container *ngIf="item">

  <!-- item['notifyType'] === 'BUSINESS_EMPLOYEE_REQUEST_REJECTED' -->
  <ng-container *ngIf="item['notifyType'] === 'BUSINESS_EMPLOYEE_REQUEST_REJECTED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          {{ item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate:30 }}
          your
          work
          experience verification failed.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'PROMOTIONAL-BENEFITS-ADDED' -->
  <ng-container *ngIf="item['notifyType'] === 'PROMOTIONAL-BENEFITS-ADDED'">
    <div data-toggle="tooltip" data-placement="top" title="GigSumo">
      Good news! We have offered you some promotional benefits to your account, valid up to
      {{item['message']}}. Please check your account.
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'BUSINESS_PAGE_DEACTIVATED' -->
  <ng-container *ngIf="item['notifyType'] === 'BUSINESS_PAGE_DEACTIVATED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          Business Page {{item['notifyData']['businessName'] | truncate:30 }} has been deactivated.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'BUSINESS_PAGE_ACTIVATED' -->
  <ng-container *ngIf="item['notifyType'] === 'BUSINESS_PAGE_ACTIVATED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          Business Page {{item['notifyData']['businessName'] | truncate:30 }} has been activated.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'BUSINESS_EMPLOYEE_REQUEST_ACCEPTED' -->
  <ng-container *ngIf="item['notifyType'] === 'BUSINESS_EMPLOYEE_REQUEST_ACCEPTED'">
    <div class="row">
      <div class="col-md-12">

        <div class="txt-500">Your work experience has been verified.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'USER_LEFT_ORGANISATION' -->
  <ng-container *ngIf="item['notifyType'] === 'USER_LEFT_ORGANISATION'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">

          {{item['notifyData']['firstName'] + " " + item['notifyData']['lastName'] | truncate:30}} has
          left
          the Organization. Any jobs, candidates, or workspaces
          previously managed by them may have been transferred to your account, along with any allocated benefits.
          Please review and validate the updates.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'JOB_SOURCE_TRANSFER' -->
  <ng-container *ngIf="item['notifyType'] === 'JOB_SOURCE_TRANSFER'">
    <div class="row">
      <div class="col-md-12">

        <div class="txt-500">
         <span *ngIf="item.message?.trim().length > 0">
            {{
              item['notifyData']['superAdmin']
                ? 'You'
                : 'Super Admin'
            }}
            have reassigned {{ item.message.split(',').length }}
           of your jobs to
            <b>
              {{
                item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName']
              }}.
            </b>
          </span>
          <span >
            You cannot manage
           {{ item.message.split(',').length === 1 ? 'this job' : 'these jobs' }}: <b title="{{ addSpace(formatCandidateIds(item.message)) }}">
            {{ formatCandidateIds(item.message) | truncate: 28 }}.
          </b>
          </span>
        </div>

      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'JOB_TARGET_TRANSFER' -->
  <ng-container *ngIf="item['notifyType'] === 'JOB_TARGET_TRANSFER'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">
          <span *ngIf="item.message?.trim().length > 0" class="transferred">
            <span>
              {{ item.message.split(',').length }} of your jobs
              {{ getCandidateCount(item.message) === 1 ? 'has' : 'have' }} been assigned to you by the
              <b>Super Admin</b>.
            </span>
            <span >
              You have access to manage
              {{ getCandidateCount(item.message) === 1 ? 'this job' : 'these jobs' }}: <b title="{{ addSpace(formatCandidateIds(item.message)) }}">
                {{ formatCandidateIds(item.message) | truncate: 28 }}.
              </b>
            </span>

         </span>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CANDIDATE_SOURCE_TRANSFER' -->
  <ng-container *ngIf="item['notifyType'] === 'CANDIDATE_SOURCE_TRANSFER'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">


          <span *ngIf="item.message?.trim().length > 0">
            {{
              item['notifyData']['superAdmin']
                ? 'You'
                : 'Super Admin'
            }}
            have reassigned {{ item.message.split(',').length }}
           of your candidates to
            <b>
              {{
                item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName']
              }}.
            </b>
          </span>
          <span >
            You cannot manage
           {{ item.message.split(',').length === 1 ? 'this candidate' : 'these candidates' }}:<b title="{{ addSpace(formatCandidateIds(item.message)) }}">
            {{ formatCandidateIds(item.message) | truncate: 26 }}.
          </b>
          </span>

        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CANDIDATE_TARGET_TRANSFER' -->
  <ng-container *ngIf="item['notifyType'] === 'CANDIDATE_TARGET_TRANSFER'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">
          <span *ngIf="item.message?.trim().length > 0" class="transferred">
            <span>
              {{ item.message.split(',').length }} of your Candidates
              {{ getCandidateCount(item.message) === 1 ? 'has' : 'have' }}
              been assigned to you by the <b>Super Admin</b>.
            </span>
            <br>
            <span>
              You have access to manage
              {{ getCandidateCount(item.message) === 1 ? 'this candidate' : 'these candidates' }}:
              <b title="{{ addSpace(formatCandidateIds(item.message)) }}">
                {{ formatCandidateIds(item.message) | truncate: 28 }}.
              </b>
            </span>
          </span>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'PLAN_ACCESS_REVOKED_SOURCE_TRANSFER' -->
  <ng-container *ngIf="item['notifyType'] === 'PLAN_ACCESS_REVOKED_SOURCE_TRANSFER'">
    <div class="row">
      <div class="col-md-12">

        <div class="txt-500">Your plan access has been deactivated by the <b>Super Admin</b>.
          Jobs, candidates, and workspaces will be transferred. You no longer have access to this plan benefits.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'PLAN_ACCESS_REVOKED_JOB_TARGET_RECEIVE' -->
  <ng-container *ngIf="item['notifyType'] === 'PLAN_ACCESS_REVOKED_JOB_TARGET_RECEIVE'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">
          <span *ngIf="item.message?.trim().length > 0" class="transferred">
            <span>
              {{ item.message.split(',').length }} of your jobs
              {{ getCandidateCount(item.message) === 1 ? 'has' : 'have' }} been assigned to you by the
              <b>Super Admin</b>.
            </span>
            <span >
              You have access to manage
              {{ getCandidateCount(item.message) === 1 ? 'this job' : 'these jobs' }}: <b title="{{ addSpace(formatCandidateIds(item.message)) }}">
                {{ formatCandidateIds(item.message) | truncate: 28 }}.
              </b>
            </span>

         </span>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'PLAN_ACCESS_REVOKED_CANDIDATE_TARGET_RECEIVE' -->
  <ng-container *ngIf="item['notifyType'] === 'PLAN_ACCESS_REVOKED_CANDIDATE_TARGET_RECEIVE'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">
          <span *ngIf="item.message?.trim().length > 0" class="transferred">
            <span>
              {{ item.message.split(',').length }} of your candidates
              {{ getCandidateCount(item.message) === 1 ? 'has' : 'have' }} been assigned to you by the
              <b>Super Admin</b>.
            </span>
            <span >
              You have access to manage
              {{ getCandidateCount(item.message) === 1 ? 'this candidate' : 'these candidates' }}: <b title="{{ addSpace(formatCandidateIds(item.message)) }}">
                {{ formatCandidateIds(item.message) | truncate: 28 }}.
              </b>
            </span>
          </span>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'PLAN_ACCESS_REVOKED_WORKSPACE_TARGET_RECEIVE' -->
  <ng-container *ngIf="item['notifyType'] === 'PLAN_ACCESS_REVOKED_WORKSPACE_TARGET_RECEIVE'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">
          <span *ngIf="item.message?.trim().length > 0" class="transferred">
            <span>
              {{ item.message.split(',').length }} of your workspaces
              {{ getCandidateCount(item.message) === 1 ? 'has' : 'have' }}
              been assigned to you by the <b>Super Admin</b>.
            </span>
            <span>
              You have access to manage
              {{ getCandidateCount(item.message) === 1 ? 'this workspace' : 'these workspaces' }}:
              <b title="{{ addSpace(formatCandidateIds(item.message)) }}">
                {{ formatCandidateIds(item.message) | truncate: 40 }}.
              </b>
            </span>
          </span>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'PLAN_SUBSCRIPTION_IMPACTED' -->
  <ng-container *ngIf="item['notifyType'] === 'PLAN_SUBSCRIPTION_IMPACTED'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">
          Your plan has been successfully updated. If you encounter any discrepancies, please contact Gigsumo
          support.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'BUSINESS_EMPLOYEE_REVOKE' -->
  <ng-container *ngIf="item['notifyType'] === 'BUSINESS_EMPLOYEE_REVOKE'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">
          You have been
           removed from the Business <b>{{item['notifyData']['businessName'] | truncate:30}}</b> by the Admin.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'PLAN_SUBSCRIPTION_IMPACTED' -->
  <ng-container *ngIf="item['notifyType'] === 'PLAN_SUBSCRIPTION_IMPACTED'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">
          Your plan has been successfully updated. If you encounter any discrepancies, please contact Gigsumo support.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'BUSINESS_FOLLOWER_ADDED' -->
  <ng-container *ngIf="item['notifyType'] === 'BUSINESS_FOLLOWER_ADDED'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">
          {{item['notifyData']['firstName'] + " " + item['notifyData']['lastName'] | truncate:30}} is
          now
          following your Business Page {{item['notifyData']['businessName'] | truncate:30}}
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'BUSINESS_EMPLOYEE_ADDED' -->
  <ng-container *ngIf="item['notifyType'] === 'BUSINESS_EMPLOYEE_ADDED'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">
          A new employee <b> {{ item?.notifyData?.firstName }} {{ item?.notifyData?.lastName }} </b> is
          added to your business <b>{{item['notifyData']['businessName'] | truncate : 22}} </b>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'POST_LIKED' -->
  <ng-container *ngIf="item['notifyType'] === 'POST_LIKED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          <ng-container [ngSwitch]="item?.notifyData?.postContentType">
            <ng-container *ngSwitchCase="'text'">
              Liked your <b>post</b>
              <a title="{{ item?.notifyData?.postContent | stripHtmlTags }}" href="javascript:void(0)"
                (click)="handlePostLinkClick($event, item?.notifyData?.postId)"
                style="text-decoration: underline"> {{
                item?.notifyData?.postContent | stripHtmlTags | truncate: 30 }}</a>
            </ng-container>
            <ng-container *ngSwitchCase="'image'">
              Liked your <a title="image" href="javascript:void(0)"
                (click)="handlePostLinkClick($event, item?.notifyData?.postId)"
                style="text-decoration: underline"><b>"Image"</b></a>.
            </ng-container>
            <ng-container *ngSwitchCase="'video'">
              Liked <a title="video" href="javascript:void(0)"
                (click)="handlePostLinkClick($event, item?.notifyData?.postId)" style="text-decoration: underline">
                <b>"Video"</b></a>.
            </ng-container>
            <ng-container *ngSwitchDefault>
              Liked your <a title="post" href="javascript:void(0)"
                (click)="handlePostLinkClick($event, item?.notifyData?.postId)"
                style="text-decoration: underline"><b>"Post"</b></a>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'POST_COMMENTED' -->
  <ng-container *ngIf="item['notifyType'] === 'POST_COMMENTED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          <ng-container [ngSwitch]="item?.notifyData?.postContentType">
            <ng-container *ngSwitchCase="'text'">
              Commented on your <b>post</b>
              <a title="{{ item?.notifyData?.postContent | stripHtmlTags }}" href="javascript:void(0)"
                (click)="handlePostLinkClick($event, item?.notifyData?.postId)"
                style="text-decoration: underline"> {{
                item?.notifyData?.postContent | stripHtmlTags | truncate: 30 }}</a>
            </ng-container>
            <ng-container *ngSwitchCase="'image'">
              Commented on your <a title="image" href="javascript:void(0)"
                (click)="handlePostLinkClick($event, item?.notifyData?.postId)"
                style="text-decoration: underline"><b>"Image"</b></a> .
            </ng-container>
            <ng-container *ngSwitchCase="'video'">
              Commented on your <a title="video" href="javascript:void(0)"
                (click)="handlePostLinkClick($event, item?.notifyData?.postId)" style="text-decoration: underline">
                <b>"Video"</b></a>.
            </ng-container>
            <ng-container *ngSwitchDefault>
              Commented on your <a title="post" href="javascript:void(0)"
                (click)="handlePostLinkClick($event, item?.notifyData?.postId)"
                style="text-decoration: underline"><b>"Post"</b></a>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'POST_SHARED' -->
  <ng-container *ngIf="item['notifyType'] === 'POST_SHARED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          <ng-container [ngSwitch]="item['notifyData']['postContentType']">
            <ng-container *ngSwitchCase="'text'">
              <div>

                shared your <b>post</b>
                <a title="{{ item['notifyData']['postContent'] | stripHtmlTags }}" href="javascript:void(0)"
                  (click)="handlePostLinkClick($event, item?.notifyData?.postId)"
                  style="text-decoration: underline"> "{{ item['notifyData']['postContent'] |
                  stripHtmlTags |
                  truncate: 30 }}"</a>
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div>

                shared your <a title="post" href="javascript:void(0)"
                  (click)="handlePostLinkClick($event, item?.notifyData?.postId)"
                  style="text-decoration: underline"><b>"Post"</b></a>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'REMOVED_FROM_MSG_GRP' -->
  <ng-container *ngIf="item['notifyType'] === 'REMOVED_FROM_MSG_GRP'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">You have been removed from Message Group
          {{item['notifyData']['messageGroupName'] | truncate : 30 }}
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'LEFT_FROM_MSG_GRP' -->
  <ng-container *ngIf="item['notifyType'] === 'LEFT_FROM_MSG_GRP'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">Left from Message Group {{item['notifyData']['messageGroupName'] |
          truncate:30}}
        </div>
      </div>

    </div>
  </ng-container>

  <!-- item['notifyType'] === 'ADDED_TO_MSG_GRP' -->
  <ng-container *ngIf="item['notifyType'] === 'ADDED_TO_MSG_GRP'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">You have been added to Message Group
          {{item['notifyData']['messageGroupName']
          | truncate : 30 }}
        </div>
      </div>

    </div>
  </ng-container>

  <!-- item['notifyType'] === 'COMMUNITY_USER_INVITE_REQUEST' -->
  <ng-container *ngIf="item['notifyType'] === 'COMMUNITY_USER_INVITE_REQUEST'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500"> {{item['notifyData']['communityName'] | truncate:30}} invited you to join
          their Community.
        </div>
      </div>
      <div class="col-md-12" style="float: right;">
        <button *ngIf="showActions" class="btn btn-special ntf-accept-btn-9347" (click)="action.emit('acceptCommunityInvitation')">Accept</button>
    <div class="ntf-msg-hint" *ngIf="!showActions">Open notifications to respond.</div>
      </div>

    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CUSTOMIZED_PLAN_REQUEST_UPDATED' -->
  <ng-container *ngIf="item['notifyType'] === 'CUSTOMIZED_PLAN_REQUEST_UPDATED'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">
          Your <strong>Scalex Plan</strong> purchase request for
          <strong>{{item['notifyData']['businessName']}}</strong>
          is processed by <strong>Gigsumo admin</strong>.
          Please, click the pay button to view the invoice and payment. Thank you.
        </div>
        <div class="text-info" *ngIf="item['status'] == 'ACTIVE'">Note: Payment link will expire in 24 hrs.</div>

      </div>
      <div class="col-md-12" style="float: right;">
        <button *ngIf="showActions && (item['status'] == 'ACTIVE')" class="btn btn-special" (click)="action.emit('scalexPayment')">Pay</button>
    <div class="ntf-msg-hint" *ngIf="!showActions && (item['status'] == 'ACTIVE')">Open notifications to respond.</div>
         <p *ngIf="item['status'] == 'INACTIVE'" class="text-danger" style="margin-top:10px;">Payment link is expired.</p>
         <p *ngIf="item['status'] == 'SUCCESS'" class="text-success" style="margin-top:10px;">Succeed payment.</p>
      </div>

    </div>
  </ng-container>

  <!-- item['notifyType'] === 'COMMUNITY_PAGE_DEACTIVATED' -->
  <ng-container *ngIf="item['notifyType'] === 'COMMUNITY_PAGE_DEACTIVATED'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500"> Community Page {{item['notifyData']['communityName'] | truncate:30}} has
          been deactivated.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'COMMUNITY_PAGE_ACTIVATED' -->
  <ng-container *ngIf="item['notifyType'] === 'COMMUNITY_PAGE_ACTIVATED'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500"> Community Page {{item['notifyData']['communityName'] | truncate:30}} has
          been activated.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'COMMUNITY_MEMBER_REQUEST_ACCEPTED' -->
  <ng-container *ngIf="item['notifyType'] === 'COMMUNITY_MEMBER_REQUEST_ACCEPTED'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">Accepted your join request to the Community
          {{item['notifyData']['communityName'] | truncate:30 }}
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'COMMUNITY_MEMBER_REQUEST_REJECTED' -->
  <ng-container *ngIf="item['notifyType'] === 'COMMUNITY_MEMBER_REQUEST_REJECTED'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">Rejected your join request to the Community
          {{item['notifyData']['communityName'] | truncate:30}}
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'COMMUNITY_USER_REQUEST_REJECTED' -->
  <ng-container *ngIf="item['notifyType'] === 'COMMUNITY_USER_REQUEST_REJECTED'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">Rejected your join request to their Community
          {{item['notifyData']['communityName'] | truncate : 30 }}
        </div>
      </div>

    </div>
  </ng-container>

  <!-- item['notifyType'] === 'COMMUNITY_USER_REQUEST_ACCEPTED' -->
  <ng-container *ngIf="item['notifyType'] === 'COMMUNITY_USER_REQUEST_ACCEPTED'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">Accepted your Community join request
        </div>
      </div>

    </div>
  </ng-container>

  <!-- item['notifyType'] === 'COMMUNITY_USER_INVITE_REQUEST_REJECTED' -->
  <ng-container *ngIf="item['notifyType'] === 'COMMUNITY_USER_INVITE_REQUEST_REJECTED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          {{item['notifyData']['firstName'] + " " +item['notifyData']['lastName'] | truncate:30}} invite
          to join Community {{item['notifyData']['communityName'] | truncate:30}} rejected.
        </div>
      </div>

    </div>
  </ng-container>

  <!-- item['notifyType'] === 'COMMUNITY_USER_INVITE_REQUEST_ACCEPTED' -->
  <ng-container *ngIf="item['notifyType'] === 'COMMUNITY_USER_INVITE_REQUEST_ACCEPTED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">Accepted your invitation to join your Community
          {{item['notifyData']['communityName'] | truncate:30 }}
        </div>
      </div>

    </div>
  </ng-container>

  <!-- item['notifyType'] === 'BUSINESS_FOLLOWER_INVITE_REQUEST_REJECTED' -->
  <ng-container *ngIf="item['notifyType'] === 'BUSINESS_FOLLOWER_INVITE_REQUEST_REJECTED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">Rejected your invitation to follow your Business Page
          {{item['notifyData']['businessName'] | truncate:30}}
        </div>
      </div>

    </div>
  </ng-container>

  <!-- item['notifyType'] === 'BUSINESS_FOLLOWER_INVITE_REQUEST_ACCEPTED' -->
  <ng-container *ngIf="item['notifyType'] === 'BUSINESS_FOLLOWER_INVITE_REQUEST_ACCEPTED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">Accepted your invitation to follow your Business Page
          {{item['notifyData']['businessName'] | truncate:30}}
        </div>
      </div>

    </div>
  </ng-container>

  <!-- item['notifyType'] === 'COMMUNITY_MEMBER_JOINED' -->
  <ng-container *ngIf="item['notifyType'] === 'COMMUNITY_MEMBER_JOINED'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">Sent you an invitation to join their Community
          {{item['notifyData']['communityName'] | truncate:30}}
        </div>
      </div>
      <div class="col-md-12" style="float: right;">
        <button *ngIf="showActions" class="btn btn-special ntf-accept-btn-9347" (click)="action.emit('acceptCommunityInvitation')">Accept</button>
    <div class="ntf-msg-hint" *ngIf="!showActions">Open notifications to respond.</div>
      </div>

    </div>
  </ng-container>

  <!-- item['notifyType'] === 'COMMUNITY_USER_JOINED' -->
  <ng-container *ngIf="item['notifyType'] === 'COMMUNITY_USER_JOINED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          {{item['notifyData']['firstName'] + " " + item['notifyData']['lastName'] | truncate:30}}
          joined
          the Community {{item['notifyData']['communityName'] | truncate:30}}
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'COMMUNITY_USER_JOIN_REQUEST' -->
  <ng-container *ngIf="item['notifyType'] === 'COMMUNITY_USER_JOIN_REQUEST'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          {{item['notifyData']['firstName'] + " " + item['notifyData']['lastName'] | truncate:30}}
          request
          to joined the Community {{item['notifyData']['communityName'] | truncate:30}}
        </div>
      </div>
      <div class="col-md-12" style="float: left;">
        <button *ngIf="showActions" class="btn btn-special ntf-accept-btn-9347" (click)="action.emit('addOrRejectMemberToCommunity')">Accept</button>
    <div class="ntf-msg-hint" *ngIf="!showActions">Open notifications to respond.</div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CONNECT_REQUEST_RECEIVED' -->
  <ng-container *ngIf="item['notifyType'] === 'CONNECT_REQUEST_RECEIVED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps ntf-message-text-4726">Sent you a connection request
        </div>
      </div>
      <div class="col-md-12">
        <button *ngIf="showActions" class="btn btn-special ntf-accept-btn-9347" (click)="action.emit('acceptConnection')">Accept</button>
    <div class="ntf-msg-hint" *ngIf="!showActions">Open notifications to respond.</div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CONNECTION_REMOVED' -->
  <ng-container *ngIf="item['notifyType'] === 'CONNECTION_REMOVED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">Removed connection between you and them
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'JOINED_NETWORK' -->
  <ng-container *ngIf="item['notifyType'] === 'JOINED_NETWORK'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          <span class="break-word">
            {{item['notifyData']['firstName'] + " " + item['notifyData']['lastName'] }}
          </span>
          joined the Network
          <span class="break-word"> {{item['notifyData']['networkName']
            }}</span>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'User_itself_remove_from_Network' -->
  <ng-container *ngIf="item['notifyType'] === 'User_itself_remove_from_Network'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          {{item['notifyData']['firstName'] + " " + item['notifyData']['lastName'] | truncate:30}} left
          the Network {{item['notifyData']['networkName'] | truncate:30}}
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'Network_Removed' -->
  <ng-container *ngIf="item['notifyType'] === 'Network_Removed'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps"> {{item['notifyData']['networkName'] | truncate:30}} you have been
          removed from the Network.
        </div>
      </div>

    </div>
  </ng-container>

  <!-- item['notifyType'] === 'NETWORK_DELETED' -->
  <ng-container *ngIf="item['notifyType'] === 'NETWORK_DELETED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          Network {{item.notifyData.networkName | truncate:30}} has been deactivated.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'NETWORK_ACTIVATED' -->
  <ng-container *ngIf="item['notifyType'] === 'NETWORK_ACTIVATED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          Network {{item.notifyData.networkName | truncate:30}} has been activated.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'NETWORK_INVITE_SENT' -->
  <ng-container *ngIf="item['notifyType'] === 'NETWORK_INVITE_SENT'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps"> {{item['notifyData']['networkName'] | truncate:30}} invited you to
          join
          their Network.
        </div>
      </div>
      <div class="col-md-12" style="float: right;">
        <button *ngIf="showActions" class="btn btn-special ntf-accept-btn-9347" (click)="action.emit('acceptNetworkMemberInvitation')">Accept</button>
    <div class="ntf-msg-hint" *ngIf="!showActions">Open notifications to respond.</div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'NETWORK_INVITE_CANCELLED' -->
  <ng-container *ngIf="item['notifyType'] === 'NETWORK_INVITE_CANCELLED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          {{item['notifyData']['firstName'] + " " + item['notifyData']['lastName'] | truncate:30}}
          Cancelled invite to join the Network {{item['notifyData']['networkName'] | truncate:30}}
        </div>
      </div>

    </div>
  </ng-container>

  <!-- item['notifyType'] === 'NETWORK_CONNECT_REQUEST_REJECTED' -->
  <ng-container *ngIf="item['notifyType'] === 'NETWORK_CONNECT_REQUEST_REJECTED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps"> {{item['notifyData']['firstName'] + " " +
          item['notifyData']['lastName']
          | truncate:30}} rejected your invite request from Network {{item['notifyData']['networkName']
          |
          truncate:30}}.
        </div>
      </div>

    </div>
  </ng-container>

  <!-- item['notifyType'] === 'NETWORK_CONNECT_REQUEST_ACCEPTED' -->
  <ng-container *ngIf="item['notifyType'] === 'NETWORK_CONNECT_REQUEST_ACCEPTED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps"> {{item['notifyData']['firstName'] + " " +
          item['notifyData']['lastName']
          | truncate:30}} joined the Network {{item['notifyData']['networkName'] | truncate:30}}
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'JOINED_TEAM' -->
  <ng-container *ngIf="item['notifyType'] === 'JOINED_TEAM'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate:30}}
          invited
          you
          to join their Workspace.
        </div>
      </div>
      <div class="col-md-12" style="float: right;">
        <button *ngIf="showActions" class="btn btn-special ntf-accept-btn-9347" (click)="action.emit('acceptTeamInvitation')">Accept</button>
    <div class="ntf-msg-hint" *ngIf="!showActions">Open notifications to respond.</div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === GigsumoConstant.LEFT_TEAM -->
  <ng-container *ngIf="item['notifyType'] === GigsumoConstant.LEFT_TEAM">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          {{item['notifyData']['firstName'] + " " + item['notifyData']['lastName'] | truncate:30}} left
          the Workspace {{item.notifyData.teamName | truncate:30}}
        </div>
      </div>

    </div>
  </ng-container>

  <!-- item['notifyType'] === GigsumoConstant.TEAM_DEACTIVATED -->
  <ng-container *ngIf="item['notifyType'] === GigsumoConstant.TEAM_DEACTIVATED">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">Workspace {{item.notifyData.teamName | truncate: 30}} has been deactivated.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- [GigsumoConstant.TEAM_INACTIVE, GigsumoConstant.LEFT_TEAM_BY_ORG_CHANGE, GigsumoConstant.S… -->
  <ng-container *ngIf="[GigsumoConstant.TEAM_INACTIVE, GigsumoConstant.LEFT_TEAM_BY_ORG_CHANGE, GigsumoConstant.SUPERADMIN_INACTIVE].includes(item['notifyType'])">
    <div class="row">
      <div class="col-md-12">
        <div *ngIf="item['notifyType'] === GigsumoConstant.TEAM_INACTIVE" class="letter-gaps">
          <b>{{item.notifyData.teamName | truncate: 30}}</b> workspace had been inactivated as the super
          admin
          no longer belongs to the Workspace.
        </div>
        <div *ngIf="item['notifyType'] ===GigsumoConstant.SUPERADMIN_INACTIVE" class="letter-gaps">
          Your access to the <b>{{item.notifyData.teamName | truncate: 30}}</b> workspace has been inactivated by the super admin.
        </div>
        <div
          *ngIf="item['notifyType'] === GigsumoConstant.LEFT_TEAM_BY_ORG_CHANGE && item['sourceId'] != GigsumoConstant.PENDING"
          class="letter-gaps">
          {{item['notifyData']['firstName'] }} {{item['notifyData']['lastName'] }} had been removed from
          the workspace <b>{{item.notifyData.teamName | truncate: 30}}</b> as he no longer belongs to the
          organization .
        </div>
        <div
          *ngIf="item['notifyType'] === GigsumoConstant.LEFT_TEAM_BY_ORG_CHANGE &&  item['sourceId'] === GigsumoConstant.PENDING"
          class="letter-gaps">
          {{item['notifyData']['firstName'] }} {{item['notifyData']['lastName'] }} could not accept the
          workspace <b>{{item.notifyData.teamName | truncate: 30}}</b> invite as
          {{item['notifyData']['firstName'] }} {{item['notifyData']['lastName'] }} left the
          organization.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'TEAM_ACTIVATED' -->
  <ng-container *ngIf="item['notifyType'] === 'TEAM_ACTIVATED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">Workspace {{item.notifyData.teamName | truncate: 30}} has been activated.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'TEAM_OWNER_UPDATE' -->
  <ng-container *ngIf="item['notifyType'] === 'TEAM_OWNER_UPDATE'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          <ng-container *ngIf="item.sourceId == item.userId">
            You are now the owner of the workspace
            <strong>{{ item.notifyData.teamName | truncate: 22 }}</strong>
          </ng-container>
          <ng-container *ngIf="item.sourceId != item.userId">
            The ownership of the workspace
            <strong>{{ item.notifyData.teamName | truncate: 22 }}</strong>
            has been transferred. You are no longer the owner of this workspace.
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'TEAM_INVITE_CANCELLED' -->
  <ng-container *ngIf="item['notifyType'] === 'TEAM_INVITE_CANCELLED'">
    <div class="row">
      <div class="col-md-12">

        <div class="letter-gaps">An invitation to join the workspace was cancelled
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'TEAMS_REMOVED' -->
  <ng-container *ngIf="item['notifyType'] === 'TEAMS_REMOVED'">
    <div class="row">
      <div class="col-md-12">

        <div class="letter-gaps"> you have been revoked
          from the Workspace, {{item['notifyData']['teamName'] | truncate:30}}
        </div>
      </div>

    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CONNECT_REQUEST_CANCELLED' -->
  <ng-container *ngIf="item['notifyType'] === 'CONNECT_REQUEST_CANCELLED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">Cancelled their connection request sent to you
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'TEAM_CONNECT_REQUEST_ACCEPTED' -->
  <ng-container *ngIf="item['notifyType'] === 'TEAM_CONNECT_REQUEST_ACCEPTED'">
    <div class="row">
      <div class="col-md-12">

        <div class="letter-gaps">Accepted your request to join the Workspace, {{item.notifyData.teamName |
          truncate:30}}
        </div>
      </div>

    </div>
  </ng-container>

  <!-- item['notifyType'] === 'DOMAIN_BUSINESS_UPDATE' -->
  <ng-container *ngIf="item['notifyType'] === 'DOMAIN_BUSINESS_UPDATE'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">
          A business page,
          <b>"{{item.message | truncate: 22}}"</b>
          has been created for your email domain and entities such as jobs, candidates, and work
          experience have
          all been updated to <b>"{{item.message | truncate: 22}}"</b>.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'UPDATED_TO_BUSINESS_PLAN' -->
  <ng-container *ngIf="item['notifyType'] === 'UPDATED_TO_BUSINESS_PLAN'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500 ntf-message-text-4726" (mouseover)="showActions && !item.read ? celebrate.emit() : null">
          Your account has been subscribed to <b>{{item.message}}</b> plan. Your jobs, candidates, or workspaces may have
          gone inactive. Please, activate them on the slots provided to you by the super admin of
          your business.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'BUSINESS_EMPLOYEE_INVITE_SENT' -->
  <ng-container *ngIf="item['notifyType'] === 'BUSINESS_EMPLOYEE_INVITE_SENT'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">
          Awaiting your work experience verification.
        </div>
      </div>

    </div>
  </ng-container>

  <!-- item['notifyType'] === 'TEAM_CONNECT_REQUEST_CANCELLED' -->
  <ng-container *ngIf="item['notifyType'] === 'TEAM_CONNECT_REQUEST_CANCELLED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">Rejected your invite request from Workspace
          <p class="breakword">{{item.notifyData.teamName }}</p>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'BUSINESS_EMPLOYEE_INVITE_REQUEST' -->
  <ng-container *ngIf="item['notifyType'] === 'BUSINESS_EMPLOYEE_INVITE_REQUEST'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          Verify {{ item['notifyData']['firstName']+" "+
          item['notifyData']['lastName'] }} work experience.
        </div>
      </div>
      <div class="col-md-12" style="float: right;">
        <button *ngIf="showActions" class="btn btn-special ntf-accept-btn-9347" (click)="action.emit('acceptBusinessEmployee')">Accept</button>
    <div class="ntf-msg-hint" *ngIf="!showActions">Open notifications to respond.</div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'BUSINESS_PAGE_FOLLOWER_INVITE_SENT' -->
  <ng-container *ngIf="item['notifyType'] === 'BUSINESS_PAGE_FOLLOWER_INVITE_SENT'">
    <div class="row">
      <div class="col-md-12">
        <div class="txt-500">You have been invited to follow our Business Page.
        </div>
      </div>
      <div class="col-md-12" style="float: right;">
        <button *ngIf="showActions" class="btn btn-special ntf-accept-btn-9347" (click)="action.emit('acceptBusinessFollowerRequest')">Accept</button>
    <div class="ntf-msg-hint" *ngIf="!showActions">Open notifications to respond.</div>
      </div>

    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CANDIDATE_INVITATION_REJECTED' -->
  <ng-container *ngIf="item['notifyType'] === 'CANDIDATE_INVITATION_REJECTED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">{{item['notifyData']['firstName'] }} {{item['notifyData']['lastName']
          }}
          rejected your invitation to apply your job <span
            style="white-space: nowrap;">{{item['notifyData']['jobTitle'] | decodeUri }}</span> for the candidate
          <span style="white-space: nowrap;">{{item['notifyData']['candidateData']['firstName'] }}
            {{item['notifyData']['candidateData']['lastName'] }}</span>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CANDIDATE_INVITATION_ACCEPTED' -->
  <ng-container *ngIf="item['notifyType'] === 'CANDIDATE_INVITATION_ACCEPTED'">
    <div class="row">
      <div class="col-md-12">
        <div *ngIf="item['notifyData']['userType']!='JOB_SEEKER'" class="letter-gaps">
          {{item['notifyData']['firstName'] }} {{item['notifyData']['lastName']
          }}
          accepted your job invite and submitted candidate <span
            style="white-space: nowrap;">{{item['notifyData']['candidateData']['firstName'] }}
            {{item['notifyData']['candidateData']['lastName'] }}</span> for the job, <span
            style="white-space: nowrap;">{{item['notifyData']['jobTitle'] | decodeUri }}.</span>
        </div>
        <div *ngIf="item['notifyData']['userType']=='JOB_SEEKER'" class="letter-gaps">Applied for the
          job, <span style="white-space: nowrap;">{{item['notifyData']['jobTitle'] | decodeUri }}.</span></div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CANDIDATE_ONBOARDED' -->
  <ng-container *ngIf="item['notifyType'] === 'CANDIDATE_ONBOARDED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          Candidate <span
            style="white-space: nowrap;">{{item['notifyData']['candidateData']['firstName']
            }} {{item['notifyData']['candidateData']['lastName'] }}</span> Onboard process for the job
          {{item['notifyData']['jobTitle'] | decodeUri}}.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CANDIDATE_REJECTED' -->
  <ng-container *ngIf="item['notifyType'] === 'CANDIDATE_REJECTED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps"> Candidate <span
            style="    white-space: nowrap;">{{item['notifyData']['candidateData']['firstName'] }}
            {{item['notifyData']['candidateData']['lastName'] }}</span> Rejected for the job <span
            style="    white-space: nowrap;">{{item['notifyData']['jobTitle'] | decodeUri}}</span>.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CANDIDATE_PREONBOARDED' -->
  <ng-container *ngIf="item['notifyType'] === 'CANDIDATE_PREONBOARDED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">Candidate <span
            style="    white-space: nowrap;">{{item['notifyData']['candidateData']['firstName'] }}
            {{item['notifyData']['candidateData']['lastName'] }}</span> Preonboarded for the job <span
            style="    white-space: nowrap;">{{item['notifyData']['jobTitle'] | decodeUri}}</span> .
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'JOB-OFFERED' -->
  <ng-container *ngIf="item['notifyType'] === 'JOB-OFFERED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps"> Candidate <span
            style="    white-space: nowrap;">{{item['notifyData']['candidateData']['firstName'] }}
            {{item['notifyData']['candidateData']['lastName'] }}</span> Offered for the job <span
            style="    white-space: nowrap;">{{item['notifyData']['jobTitle'] | decodeUri}}</span>.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] ==='OFFER-WITHDRAWN' -->
  <ng-container *ngIf="item['notifyType'] ==='OFFER-WITHDRAWN'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps"> Candidate <span
            style="    white-space: nowrap;">{{item['notifyData']['candidateData']['firstName'] }}
            {{item['notifyData']['candidateData']['lastName'] }}</span> Offer Withdrawn for the job
          <span style="    white-space: nowrap;">{{item['notifyData']['jobTitle'] | decodeUri}}</span>.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] ==='CANDIDATE BACKOUT' -->
  <ng-container *ngIf="item['notifyType'] ==='CANDIDATE BACKOUT'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps"> Candidate <span
            style="    white-space: nowrap;">{{item['notifyData']['candidateData']['firstName'] }}
            {{item['notifyData']['candidateData']['lastName'] }}</span> Backed Out for the job <span
            style="    white-space: nowrap;">{{item['notifyData']['jobTitle'] | decodeUri}}</span>.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CANDIDATE-SHORTLISTED' -->
  <ng-container *ngIf="item['notifyType'] === 'CANDIDATE-SHORTLISTED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps"> Candidate <span
            style="white-space: nowrap;">{{item['notifyData']['candidateData']['firstName'] }}
            {{item['notifyData']['candidateData']['lastName'] }}</span> Shortlisted for the job
          {{item['notifyData']['jobTitle'] | decodeUri}} .
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'INTERVIEW-SCHEDULED' -->
  <ng-container *ngIf="item['notifyType'] === 'INTERVIEW-SCHEDULED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          Candidate <span
            style="white-space: nowrap;">{{item['notifyData']['candidateData']['firstName']
            }} {{item['notifyData']['candidateData']['lastName'] }}</span> Scheduled an interview for
          the
          job <span style="white-space: nowrap;">{{item['notifyData']['jobTitle'] | decodeUri}}</span>.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CANDIDATE_GOT_SELECTED' -->
  <ng-container *ngIf="item['notifyType'] === 'CANDIDATE_GOT_SELECTED'">
    <div class="row">
      <div class="col-md-12">

        <div class="letter-gaps">
          Candidate <span
            style="white-space: nowrap;">{{item['notifyData']['candidateData']['firstName']
            }} {{item['notifyData']['candidateData']['lastName'] }}</span> Selected for the job <span
            style="white-space: nowrap;">{{item['notifyData']['jobTitle'] | decodeUri}}</span>.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'JOB_STATUS_CHANGED' -->
  <ng-container *ngIf="item['notifyType'] === 'JOB_STATUS_CHANGED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          <span style="white-space: nowrap;">{{ (item?.notifyData?.jobData?.jobTitle | decodeUri) || 'N/A' }}</span>
          that you had applied for has been moved to
          <span style="white-space: nowrap;">{{ item?.message || 'N/A' }}</span>.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'RESUME_REQUEST_ACCEPTED' || item['notifyType'] === 'RESUME_UPDATED… -->
  <ng-container *ngIf="item['notifyType'] === 'RESUME_REQUEST_ACCEPTED' || item['notifyType'] === 'RESUME_UPDATED' ">
    <div class="row">
      <div class="col-md-12">
        <div *ngIf="item['notifyData']['userType'] != 'JOB_SEEKER'" class="letter-gaps">
          {{item['notifyData']['firstName'] }}
          {{item['notifyData']['lastName'] }} uploaded resume for the candidate <span
            style="white-space: nowrap;">{{item['notifyData']['candidateData']['firstName'] }}
            {{item['notifyData']['candidateData']['lastName'] }}</span> that you have requested.
        </div>
        <div *ngIf="item['notifyData']['userType'] == 'JOB_SEEKER'" class="letter-gaps">Resume uploaded
          as requested</div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'RESUME_REQUEST_INITIATED' -->
  <ng-container *ngIf="item['notifyType'] === 'RESUME_REQUEST_INITIATED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          {{item['notifyData']['firstName'] }} {{item['notifyData']['lastName'] }} requested the resume for
          the candidate <b style="white-space: nowrap;">{{item['notifyData']['candidateData']?.['firstName'] }}
            {{item['notifyData']['candidateData']?.['lastName'] }}</b>&nbsp;<b>[{{item['notifyData']['candidateData']?.['candidateId'] }}]</b>.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CREDITS_CONSUMPTION_ALERT' -->
  <ng-container *ngIf="item['notifyType'] === 'CREDITS_CONSUMPTION_ALERT'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          <span><b> {{item['notifyData']['creditsForConsumption'] }} </b> credits will be deducted for
            <span
              *ngIf="item['notifyData']['jobsCount'] == 1 ||item['notifyData']['jobsToBeActivatedCount'] == 1 ">
              <b>
                {{item['notifyData']['jobsCount']+ item['notifyData']['jobsToBeActivatedCount']|
                Adding}}
              </b> job
            </span> <span
              *ngIf="item['notifyData']['jobsCount'] >1 ||item['notifyData']['jobsToBeActivatedCount'] > 1"><b>
                {{item['notifyData']['jobsCount']+ item['notifyData']['jobsToBeActivatedCount']| Adding
                }}
              </b>
              jobs </span>
            <span
              *ngIf="item['notifyData']['jobsCount']>=1 && item['notifyData']['candidatesCount']>=1 || item['notifyData']['jobsToBeActivatedCount']>=1 && item['notifyData']['candidatesToBeActivatedCount']>=1">
              and </span>
            <span
              *ngIf="item['notifyData']['candidatesCount'] == 1 || item['notifyData']['candidatesToBeActivatedCount'] == 1"><b>
                {{item['notifyData']['candidatesCount']+item['notifyData']['candidatesToBeActivatedCount']
                | Adding}} </b> candidate </span> <span
              *ngIf="item['notifyData']['candidatesCount'] >1 || item['notifyData']['candidatesToBeActivatedCount'] >1">
              <b>
                {{item['notifyData']['candidatesCount']
                +item['notifyData']['candidatesToBeActivatedCount']| Adding }} </b> candidates </span>
            12
            AM</span>
          <span *ngIf="item['notifyData']['creditsInNeed']!=null"> You need
            <b>{{item['notifyData']['creditsInNeed'] }}</b> more credits to keep your <span
              *ngIf="item['notifyData']['jobsCount']>0"> jobs and </span><span
              *ngIf="item['notifyData']['candidatesCount']>0"> candidates </span>active So Please
            purchase
            credits</span>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'INSUFFICIENT_CREDITS_ALERT' -->
  <ng-container *ngIf="item['notifyType'] === 'INSUFFICIENT_CREDITS_ALERT'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          <span> You need <b>{{item['creditsInNeed'] }}</b> more credits to keep your <span
              *ngIf="item['notifyData']['jobsCount']>0"> {{item['notifyData']['jobsCount'] }} jobs
              and</span><span *ngIf="item['notifyData']['candidatesCount']>0">
              {{item['notifyData']['candidatesCount'] }} candidates
            </span>active So Please purchase credits</span>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'JOB_OWNER_REQUEST' -->
  <ng-container *ngIf="item['notifyType'] === 'JOB_OWNER_REQUEST'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps ntf-message-text-4726">
          The job (Job ID: <b>{{item.notifyData.jobId}}</b>) you accepted the offer is now
          currently on <b>document verification process</b>.
          Only after completing document verification you can move forward to
          onboarding status.
          So, please upload all the mandatory documents for verification.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'JOB_OWNER_ADDITIONAL_REQUEST' -->
  <ng-container *ngIf="item['notifyType'] === 'JOB_OWNER_ADDITIONAL_REQUEST'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps ntf-message-text-4726">
          Additional documents requested for the job (Job ID: <b>{{item.notifyData.jobId}}</b>) offer you accepted.
          Please upload the requested documents for verification.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CANDIDATE_DOCUMENT_REJECTION' -->
  <ng-container *ngIf="item['notifyType'] === 'CANDIDATE_DOCUMENT_REJECTION'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps ntf-message-text-4726">

          The document <b>{{item.message | underscoreRemovePipe | titlecase}}</b> you uploaded is <b>Rejected</b>
          due to <b>{{item.notifyEntityId}}</b>.
          Please go and check the job id (Job ID: <b>{{item.notifyData.jobId}}</b>) and
          reupload the document for verification.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CANDIDATE_DOCUMENT_EXPIRED' -->
  <ng-container *ngIf="item['notifyType'] === 'CANDIDATE_DOCUMENT_EXPIRED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps ntf-message-text-4726">
          The document you uploaded is <b>Expired</b>.
          Please go and check the job id (Job ID: <b>{{item.notifyData.jobId}})</b> and
          reupload the document for verification.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CANDIDATE_OWNER_SUBMISSION' -->
  <ng-container *ngIf="item['notifyType'] === 'CANDIDATE_OWNER_SUBMISSION'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps ntf-message-text-4726">
          The documents you requested from the candidate are <b>Submitted</b> for
          the verification. Please go and check the (Job ID: <b>{{item.notifyData.jobId}}</b>).
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CANDIDATE_DOCUMENT_REUPLOAD' -->
  <ng-container *ngIf="item['notifyType'] === 'CANDIDATE_DOCUMENT_REUPLOAD'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps ntf-message-text-4726">
          The candidate reuploaded the <b>{{item.message}}</b> for
          the verification. Previously uploaded <b>{{item.message}}</b> was rejected.
          Please go and verify the (Job ID: <b>{{item.notifyData.jobId}}</b>).
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CANDIDATE_EXPIRED_DOCUMENT_REUPLOAD' -->
  <ng-container *ngIf="item['notifyType'] === 'CANDIDATE_EXPIRED_DOCUMENT_REUPLOAD'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps ntf-message-text-4726">
          The candidate reuploaded the document <b>{{item.message}}</b> for
          the verification. The previously uploaded document is expired.
          Please go and check the (Job ID: <b>{{item.notifyData.jobId}}</b>).
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'CANDIDATE_DOCUMENT_ALL_VERIFIED' -->
  <ng-container *ngIf="item['notifyType'] === 'CANDIDATE_DOCUMENT_ALL_VERIFIED'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps ntf-message-text-4726">
          The documents you uploaded for the (Job ID: <b>{{item.notifyData.jobId}}</b>) is all verified.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- item['notifyType'] === 'ADMIN_ACTION_BY_REPORT' -->
  <ng-container *ngIf="item['notifyType'] === 'ADMIN_ACTION_BY_REPORT'">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps" [ngSwitch]="item['message']">
          <ng-container *ngSwitchCase="'BLOCKED'">
            <ng-container
              *ngIf="item['notifyEntity'] === 'CANDIDATE' || item['notifyEntity'] === 'JOB'">
              Your {{item['notifyEntity']|lowercase }} (<b>{{item['notifyEntityId'] }}</b>) has been
              blocked by
              the admin
            </ng-container>
            <ng-container [ngSwitch]="item['notifyData']['postContentType']">
              <ng-container *ngSwitchCase="'text'">
                Your {{ item['notifyEntity'] | lowercase }} <a
                  title="{{ item['notifyData']['postContent'] | stripHtmlTags}}"
                  [routerLink]="['/landingPage']" [queryParams]="{ postId: item['notifyEntityId'] }"
                  style="text-decoration: underline"> "{{
                  item['notifyData']['postContent'] | stripHtmlTags | truncate: 30 }}"</a>
                has been blocked by the admin.
              </ng-container>
              <ng-container *ngSwitchCase="'image'">
                Your post <a title="image" [routerLink]="['/landingPage']"
                  [queryParams]="{ postId: item['notifyEntityId'] }"
                  style="text-decoration: underline"><b>"Image"</b></a> has been blocked by the admin.
              </ng-container>
              <ng-container *ngSwitchCase="'video'">
                Your post <a title="video" [routerLink]="['/landingPage']"
                  [queryParams]="{ postId: item['notifyEntityId'] }" style="text-decoration: underline">
                  <b>"Video"</b></a> has been blocked by the admin.
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ['BUSINESS_PAGE_CONTACT_INVITE', 'BUSINESS_COLLABRATION_INVITE','BUSINESS_COLLABRATION_INV… -->
  <ng-container *ngIf="['BUSINESS_PAGE_CONTACT_INVITE', 'BUSINESS_COLLABRATION_INVITE','BUSINESS_COLLABRATION_INVITE_ACCEPTED','BUSINESS_PAGE_CONTACT_INVITE_ACCEPTED'].includes(item['notifyType'])">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps">
          <b>
            {{ item['notifyType']=='BUSINESS_PAGE_CONTACT_INVITE_ACCEPTED'
              ? (item?.notifyData?.firstName + ' ' + item?.notifyData?.lastName)
              : (item?.notifyData?.businessName | truncate:22) }}
          </b>
          <ng-container [ngSwitch]="item?.notifyType">
            <span *ngSwitchCase="'BUSINESS_PAGE_CONTACT_INVITE'"> has invited you to add as an
              individual contact to their business.</span>
            <span *ngSwitchCase="'BUSINESS_COLLABRATION_INVITE'"> has invited your business to add as a
              B2B contact.</span>
            <span *ngSwitchCase="'BUSINESS_COLLABRATION_INVITE_ACCEPTED'"> accepted your contact
              request.</span>
            <span *ngSwitchCase="'BUSINESS_PAGE_CONTACT_INVITE_ACCEPTED'"> accepted your contact request. Please edit the business connection and enable your employees who you want to work with them.
             </span>


          </ng-container>
        </div>
      </div>
      <div
        *ngIf="!['BUSINESS_COLLABRATION_INVITE_ACCEPTED', 'BUSINESS_PAGE_CONTACT_INVITE_ACCEPTED'].includes(item['notifyType'])"
        class="col-md-12" style="float: right;">
        <button *ngIf="showActions" class="btn btn-special ntf-accept-btn-9347" (click)="action.emit('opencontactmodal')">Accept</button>
    <div class="ntf-msg-hint" *ngIf="!showActions">Open notifications to respond.</div>
      </div>
    </div>
  </ng-container>

  <!-- isSupportedNotifyType(item['notifyType']) -->
  <ng-container *ngIf="isSupportedNotifyType(item['notifyType'])">
    <div class="row">
      <div class="col-md-12">
        <div class="letter-gaps ntf-message-text-4726" style="cursor: pointer;">
          <ng-container [ngSwitch]="item['notifyType']">
            <span *ngSwitchCase="'MONTHLY_ADD_ON_CREDITS'">
              <b>Your monthly credits have been reset.</b>
            </span>
            <span *ngSwitchCase="'MONTHLY_REFRESH_ALERT'">
              Your monthly free credits have been reset, valid until <b>{{ item['message'] }}</b>.
            </span>
            <span *ngSwitchCase="'CREDIT_COSNUMED_FOR_JOBS'">
              <b>{{ item['message'] }}</b> Credits Consumed for <b>{{ item['notifyData']['jobsCount']
                }}</b> Jobs.
            </span>
            <span *ngSwitchCase="'CREDIT_REWARDED'">
              <b>{{ item['message'] }}</b> free credits have been credited to your account by the
              platform.
            </span>
            <span *ngSwitchCase="'BUSINESS_PAGE_BLOCKED'">
              Your business page <b>{{ item['notifyData']['businessName'] | truncate: 30 }}</b> has been
              blocked by the
              platform. Please contact GigSumo support for further information.
            </span>
            <span *ngSwitchCase="'BUSINESS_PAGE_UNBLOCKED'">
              Your business page <b>{{ item['notifyData']['businessName'] | truncate: 30 }}</b> has been
              unblocked.
            </span>

            <span *ngSwitchCase="'STRIPE_INVOICE_FAILURE'">
              Your {{ item['notifyEntity'] }} plan renewal has failed on {{ item['notifyTime']
              | date:'MM/dd/yyyy'}}. Please check billing history for more details.
            </span>
            <span *ngSwitchCase="'STRIPE_PAYMENT_TRANSACTION_FAILURE'">
              Your {{ item['notifyEntity'] }} plan purchase has failed on {{ item['notifyTime']
              | date:'MM/dd/yyyy'}}. Please check billing history for more details.
            </span>

            <span *ngSwitchCase="'STRIPE_INVOICE_SUCCESS'">
              Your {{ item['message'] }} plan has been renewed on <b>{{ item?.notifyTime | date:'MM/dd/yyyy'}}</b>.
            </span>
            <span *ngSwitchCase="'MEMBERSHIP_UPDATED'" (mouseover)="showActions && !item.read ? celebrate.emit() : null">
              <b>{{ item['notifyData'] }}</b> Congratulations! Your account has been successfully upgraded to <b>{{ item['notifyEntity'] }}</b> plan.
            </span>
            <span *ngSwitchCase="'SUGGESTED_CANDIDATES_TO_JOB_OWNER'">
              Top candidates found for {{ item['notifyData']['jobTitle'] | decodeUri }} (Job ID: <b>{{ item['notifyData']['jobId'] }}</b>). Explore profiles that match your requirements now.
            </span>
            <span *ngSwitchCase="'SUGGESTED_JOBS_TO_CANDIDATE_OWNER'">
              Top {{ item['notifyData']['jobTitle'] | decodeUri }} job matches found (Candidate ID: <b>{{ item['notifyData']['candidateId'] }}</b>)! Explore roles that fit your profile now.
            </span>
            <span *ngSwitchCase="'SUGGESTED_JOB_REFRESH'">
              We just refreshed the marketplace jobs for the candidate {{ item['notifyData']['candidateName'] }} (Candidate ID: <b>{{ item['notifyData']['candidateId'] }}</b>).Explore roles that fit your profile now.
            </span>
            <span *ngSwitchCase="'SUGGESTED_CANDIDATE_REFRESH'">
              We just refreshed the marketplace candidates for the job {{ item['notifyData']['jobTitle'] | decodeUri }} (Job ID: <b>{{ item['notifyData']['jobId'] }}</b>).  Explore profiles that match your requirements now.
            </span>
            <span *ngSwitchCase="'JOB_APPLIED_TO_JOB_OWNER'">
              A candidate applied for {{ item['notifyData']['jobTitle'] | decodeUri }} (Candidate Id: <b>{{ item['message'] }}</b>). Review Job Id <b>{{ item['notifyData']['jobId'] }}</b> and their match score.
            </span>
            <span *ngSwitchCase="'JOB_APPLIED_TO_CANDIDATE_OWNER'">
              Your application for {{ item['notifyData']['jobTitle'] | decodeUri }} (Job Id: <b>{{ item['notifyData']['jobId'] }}</b>) has been submitted successfully. Your profile (Candidate Id: <b>{{ item['notifyData']['candidateId'] }}</b>) matches well with the job requirements.
            </span>
            <span *ngSwitchCase="'CREDIT_COSNUMED_FOR_CANDIDATES'"> <b>{{item['message'] }}</b> Credits
              Consumed for <b>
                {{item['notifyData']['candidatesCount'] }} </b>Candidates.</span>
            <span *ngSwitchCase="'JOBS_DOWNGRADED'">
              <b>{{ item['notifyData']['jobsDowngradedCount'] }}</b> of your jobs is downgraded.
            </span>
            <span *ngSwitchCase="'CANDIDATES_DOWNGRADED'">
              <b>{{ item['notifyData']['candidatesDowngradedCount'] }}</b> of your candidates is
              downgraded.
            </span>
            <span *ngSwitchCase="'JOBS_DOWNGRADING_ALERT'">
              <b>{{ item['notifyData']['jobsDowngradedCount'] }}</b> of your jobs will be downgraded as
              the number of days it
              had been upgraded for, expired.
            </span>
            <span *ngSwitchCase="'CANDIDATES_DOWNGRADING_ALERT'">
              <b>{{ item['notifyData']['candidatesDowngradedCount'] }}</b> of your candidates will be
              downgraded as the number
              of days it had been upgraded for, expired.
            </span>

            <ng-container *ngSwitchCase="'ADMIN_ACTION_ON_REPORT'">
              <ng-container [ngSwitch]="item['message']">
                <ng-container *ngSwitchCase="'BLOCKED'">
                  <ng-container
                    *ngIf="item['notifyEntity'] === 'CANDIDATE' || item['notifyEntity'] === 'JOB'">
                    The {{ item['notifyEntity'] | lowercase }} (<b>{{ item['notifyEntityId'] }}</b>) you
                    reported has
                    been blocked by the admin.
                  </ng-container>
                  <ng-container [ngSwitch]="item['notifyData']['postContentType']">
                    <ng-container *ngSwitchCase="'text'">
                      The {{ item['notifyEntity'] | lowercase }} "{{ item['notifyData']['postContent'] |
                      stripHtmlTags | truncate:
                      30
                      }}" you reported has been blocked by the admin.
                    </ng-container>
                    <ng-container *ngSwitchCase="'image'">
                      The post <b>"Image"</b> you reported has been blocked by the admin.
                    </ng-container>
                    <ng-container *ngSwitchCase="'video'">
                      The post <b>"Video"</b> you reported has been blocked by the admin.
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="'FLAG_RECEIVED_ACKNOWLEDGEMENT'">
              <ng-container [ngSwitch]="item['message']">
                <ng-container *ngSwitchCase="'INREVIEW'">
                  <ng-container
                    *ngIf="item['notifyEntity'] === 'CANDIDATE' || item['notifyEntity'] === 'JOB'">
                    The {{ item['notifyEntity'] | lowercase }} (<b>{{ item['notifyEntityId'] }}</b>) you
                    reported is
                    being reviewed by the admin.
                  </ng-container>
                  <ng-container [ngSwitch]="item['notifyData']['postContentType']">
                    <ng-container *ngSwitchCase="'text'">
                      The {{ item['notifyEntity'] | lowercase }} "{{ item['notifyData']['postContent'] |
                      stripHtmlTags |
                      truncate:
                      30 }}" you reported is being reviewed by the admin.
                    </ng-container>
                    <ng-container *ngSwitchCase="'image'">
                      The post <b>"Image"</b> you reported is being reviewed by the admin.
                    </ng-container>
                    <ng-container *ngSwitchCase="'video'">
                      The post <b>"Video"</b> you reported is being reviewed by the admin.
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>

            <span *ngSwitchCase="'CONTRACT_AGREEMENT_DOCUMENT_UPLOADED'">
              Document template <b>{{ item['notifyData']?.['documentName'] }}</b> has been uploaded by
              <b>{{ item['notifyData']?.['businessName'] }}</b>. Please review the document to proceed.
            </span>
            <span *ngSwitchCase="'CONTRACT_COMPANY_DOC_CHECKLIST_CREATED'">
              <b>{{ item['notifyData']?.['businessName'] }}</b> has requested you to upload the document
              <b>{{ item['notifyData']?.['documentName'] }}</b>. Please upload the required document to proceed.
            </span>
            <span *ngSwitchCase="'CONTRACT_COMPANY_DOC_UPLOADED'">
              Company document <b>{{ item['notifyData']?.['documentName'] }}</b> has been uploaded by
              <b>{{ item['notifyData']?.['businessName'] }}</b>. Please review the document to proceed.
            </span>
            <span *ngSwitchCase="'CONTRACT_COMPANY_DOC_VERIFIED'">
              <b>{{ item['notifyData']?.['businessName'] }}</b> has verified your company document
              <b>{{ item['notifyData']?.['documentName'] }}</b>.
            </span>
            <span *ngSwitchCase="'CONTRACT_COMPANY_DOC_REJECTED'">
              <b>{{ item['notifyData']?.['businessName'] }}</b> has rejected your company document
              <b>{{ item['notifyData']?.['documentName'] }}</b>. Reason: <b>{{ item['notifyData']?.['rejectionReason'] }}</b>. Please re-upload the corrected document.
            </span>
            <span *ngSwitchCase="'CONTRACT_AGREEMENT_SIGNING_REQUESTED'">
              <b>{{ item['notifyData']?.['businessName'] }}</b> has prepared the document template
              <b>{{ item['notifyData']?.['documentName'] }}</b> for signing. Your signature is required to proceed.
            </span>
            <span *ngSwitchCase="'CONTRACT_AGREEMENT_SIGNED'">
              Document template <b>{{ item['notifyData']?.['documentName'] }}</b> has been successfully signed by
              <b>{{ item['notifyData']?.['businessName'] }}</b>. Please review the signed document.
            </span>
            <span *ngSwitchCase="'CONTRACT_AGREEMENT_ACCEPTED'">
              <b>{{ item['notifyData']?.['businessName'] }}</b> has accepted your document template
              <b>{{ item['notifyData']?.['documentName'] }}</b>.
            </span>
            <span *ngSwitchCase="'CONTRACT_AGREEMENT_REJECTED'">
              <b>{{ item['notifyData']?.['businessName'] }}</b> has rejected your document template
              <b>{{ item['notifyData']?.['documentName'] }}</b>. Reason: <b>{{ item['notifyData']?.['rejectionReason'] }}</b>. Please re-upload the corrected document.
            </span>

            <span *ngSwitchCase="'CONTRACT_WORK_ORDER_INITIATED'">
              <b>{{ item['notifyData']?.['businessName'] }}</b> has initiated a work order (<b>{{ extractWorkOrderId(item['message']) }}</b>). Please review and respond with your acceptance or rejection.
            </span>
            <span *ngSwitchCase="'CONTRACT_WORK_ORDER_ACCEPTED'">
              <b>{{ item['notifyData']?.['businessName'] }}</b> has accepted the work order (<b>{{ extractWorkOrderId(item['message']) }}</b>).
            </span>
            <span *ngSwitchCase="'CONTRACT_WORK_ORDER_REJECTED'">
              <b>{{ item['notifyData']?.['businessName'] }}</b> has rejected the work order (<b>{{ extractWorkOrderId(item['message']) }}</b>).
            </span>
            <span *ngSwitchCase="'CONTRACT_WORK_ORDER_REVISED'">
              <b>{{ item['notifyData']?.['businessName'] }}</b> has revised the work order (<b>{{ extractWorkOrderId(item['message']) }}</b>). Please review the updated details.
            </span>
            <span *ngSwitchCase="'CONTRACT_WORK_ORDER_VOIDED'">
              <b>{{ item['notifyData']?.['businessName'] }}</b> has cancelled the work order (<b>{{ extractWorkOrderId(item['message']) }}</b>).
            </span>

            <span *ngSwitchCase="'CONTRACT_INITIATED'">
              Contract initiated for candidate (<b>{{ item['notifyData']?.['candidateId'] }}</b>) by
              <b>{{ item['notifyData']?.['businessName'] }}</b>. Please review the details and sign the required documents.
            </span>
            <span *ngSwitchCase="'CONTRACT_INVOICE_SUBMITTED'">
              Invoice <b>{{ item['notifyData']?.['invoiceId'] }}</b> has been submitted by
              <b>{{ item['notifyData']?.['supplierBusinessName'] }}</b> for candidate
              <b>{{ item['notifyData']?.['candidateName'] }}</b> (<b>{{ item['notifyData']?.['candidateId'] }}</b>). Please review and take action.
            </span>
            <span *ngSwitchCase="'CONTRACT_INVOICE_UPDATED'">
              Invoice <b>{{ item['notifyData']?.['invoiceId'] }}</b> for candidate
              <b>{{ item['notifyData']?.['candidateName'] }}</b> (<b>{{ item['notifyData']?.['candidateId'] }}</b>) has been updated by
              <b>{{ item['notifyData']?.['supplierBusinessName'] }}</b>. Please review the latest figures before approving.
            </span>
            <span *ngSwitchCase="'CONTRACT_INVOICE_APPROVED'">
              Invoice <b>{{ item['notifyData']?.['invoiceId'] }}</b> for candidate
              <b>{{ item['notifyData']?.['candidateName'] }}</b> (<b>{{ item['notifyData']?.['candidateId'] }}</b>) has been approved by
              <b>{{ item['notifyData']?.['businessName'] }}</b>. Payment will be processed per agreed terms.
            </span>
            <span *ngSwitchCase="'CONTRACT_INVOICE_REJECTED'">
              Invoice <b>{{ item['notifyData']?.['invoiceId'] }}</b> for candidate
              <b>{{ item['notifyData']?.['candidateName'] }}</b> (<b>{{ item['notifyData']?.['candidateId'] }}</b>) has been rejected by
              <b>{{ item['notifyData']?.['businessName'] }}</b>. Reason: <b>{{ item['notifyData']?.['rejectionReason'] }}</b>. Please review and resubmit.
            </span>
            <span *ngSwitchCase="'CONTRACT_INVOICE_PAID'">
              Payment has been processed for Invoice <b>{{ item['notifyData']?.['invoiceId'] }}</b> — candidate
              <b>{{ item['notifyData']?.['candidateName'] }}</b> (<b>{{ item['notifyData']?.['candidateId'] }}</b>).
              <b>{{ item['notifyData']?.['customerBusinessName'] }}</b> has marked this invoice as paid to
              <b>{{ item['notifyData']?.['supplierBusinessName'] }}</b>.
            </span>
            <span *ngSwitchCase="'CONTRACT_PAYMENT_RECEIVED'">
              Payment receipt confirmed for Invoice <b>{{ item['notifyData']?.['invoiceId'] }}</b> — candidate
              <b>{{ item['notifyData']?.['candidateName'] }}</b> (<b>{{ item['notifyData']?.['candidateId'] }}</b>).
              <b>{{ item['notifyData']?.['supplierBusinessName'] }}</b> has acknowledged receipt of payment from
              <b>{{ item['notifyData']?.['customerBusinessName'] }}</b>.
            </span>
            <span *ngSwitchCase="'CONTRACT_INVOICE_VOIDED'">
              Invoice <b>{{ item['notifyData']?.['invoiceId'] }}</b> for candidate
              <b>{{ item['notifyData']?.['candidateName'] }}</b> (<b>{{ item['notifyData']?.['candidateId'] }}</b>) has been voided. No further action is required on this invoice.
            </span>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
